//
import documentosMachine from "./machine"
import { actionsNoCare } from "../../constants/actionsNoCare"
export const { initialState } = documentosMachine

const Documentos = (state = initialState, action) => {
  //
  if (
    !actionsNoCare.includes(action.type) &&
    !action.type.startsWith("@@") &&
    action.type.startsWith("documentos/")
  ) {
    if (!documentosMachine.states[state.value]?.on?.[action.type]) {
      console.error(
        `documentosMachine: No hay transición definida para la acción ${action.type} en el estado ${state.value}`
      )
    } else {
      return documentosMachine.transition(state, action)
    }
  }
  return state
}

export default Documentos
